import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@/components/Header'
import Back from '@/components/Back'
import PageLayout from '@/components/PageLayout'
import { APP_NAME, PRIVACY_POLICY_EMAIL, PRIVACY_POLICY_COMPANY } from '@/config/constants'

/** 渲染列表项 */
const ListItem = ({ text }: { text: string }) => (
  <li className="flex items-start">
    <span className="mr-2 flex-shrink-0">•</span>
    <span>{text}</span>
  </li>
)

/** 渲染带列表的段落组 */
const SectionBlock = ({ title, paragraphs, items, subSections }: {
  title: string
  paragraphs?: string[]
  items?: string[]
  subSections?: { title: string; paragraphs?: string[]; items?: string[] }[]
}) => (
  <div className="mb-10">
    <h2 className="text-6 font-bold mb-5">{title}</h2>
    {paragraphs?.map((p, i) => (
      <p key={i} className="text-4 mb-6 leading-6">{p}</p>
    ))}
    {items && items.length > 0 && (
      <ul className="space-y-4 list-none mb-4 text-4">
        {items.map((item, i) => <ListItem key={i} text={item} />)}
      </ul>
    )}
    {subSections?.map((sub, i) => (
      <div key={i} className="mb-6 ml-1">
        {sub.title && <h3 className="text-6 font-bold mb-4">{sub.title}</h3>}
        {sub.paragraphs?.map((p, j) => (
          <p key={j} className="text-4 mb-6 leading-6">{p}</p>
        ))}
        {sub.items && sub.items.length > 0 && (
          <ul className="space-y-4 list-none mb-4 text-4">
            {sub.items.map((item, j) => <ListItem key={j} text={item} />)}
          </ul>
        )}
      </div>
    ))}
  </div>
)

export default React.memo(function PrivacyPolicy() {
  const { t } = useTranslation()
  const n = { name: APP_NAME }

  const sections = useMemo(() => [
    // Section 1: 引言
    {
      title: t('pp_s1_title', n),
      paragraphs: [t('pp_s1_p1', n), t('pp_s1_p2', n)],
      items: [t('pp_s1_l1', n), t('pp_s1_l2', n), t('pp_s1_l3', n), t('pp_s1_l4', n), t('pp_s1_l5', n), t('pp_s1_l6', n)],
      subSections: [
        {
          title: '',
          paragraphs: [t('pp_s1_p3', n), t('pp_s1_p4', n), t('pp_s1_p5', n)],
          items: [t('pp_s1_n1', n), t('pp_s1_n2', n), t('pp_s1_n3', n)],
        },
        {
          title: '',
          paragraphs: [t('pp_s1_p6', n)],
        }
      ]
    },
    // Section 2: 我们收集的个人数据
    {
      title: t('pp_s2_title', n),
      paragraphs: [t('pp_s2_p1', n)],
      items: [t('pp_s2_l1', n), t('pp_s2_l2', n), t('pp_s2_l3', n)],
      subSections: [
        {
          title: '',
          paragraphs: [t('pp_s2_p2', n), t('pp_s2_p3', n)],
          items: [t('pp_s2_l4', n), t('pp_s2_l5', n), t('pp_s2_l6', n), t('pp_s2_l7', n), t('pp_s2_l8', n)],
        },
        {
          title: t('pp_s2a_title', n),
          paragraphs: [t('pp_s2a_p1', n)],
          items: [t('pp_s2a_l1', n), t('pp_s2a_l2', n), t('pp_s2a_l3', n), t('pp_s2a_l4', n), t('pp_s2a_l5', n), t('pp_s2a_l6', n), t('pp_s2a_l7', n), t('pp_s2a_l8', n), t('pp_s2a_l9', n), t('pp_s2a_l10', n), t('pp_s2a_l11', n), t('pp_s2a_l12', n)],
        },
        {
          title: '',
          paragraphs: [t('pp_s2a_p2', n)],
        },
        {
          title: t('pp_s2b_title', n),
          paragraphs: [t('pp_s2b_p1', n)],
          items: [t('pp_s2b_l1', n), t('pp_s2b_l2', n), t('pp_s2b_l3', n), t('pp_s2b_l4', n), t('pp_s2b_l5', n), t('pp_s2b_l6', n), t('pp_s2b_l7', n), t('pp_s2b_l8', n)],
        },
        {
          title: '',
          paragraphs: [t('pp_s2b_p2', n)],
          items: [t('pp_s2b_l9', n), t('pp_s2b_l10', n), t('pp_s2b_l11', n)],
        },
        {
          title: t('pp_s2c_title', n),
          paragraphs: [t('pp_s2c_p1', n)],
          items: [t('pp_s2c_l1', n), t('pp_s2c_l2', n), t('pp_s2c_l3', n), t('pp_s2c_l4', n), t('pp_s2c_l5', n), t('pp_s2c_l6', n), t('pp_s2c_l7', n), t('pp_s2c_l8', n)],
        },
        {
          title: t('pp_s2d_title', n),
          paragraphs: [t('pp_s2d_p1', n)],
          items: [t('pp_s2d_l1', n), t('pp_s2d_l2', n), t('pp_s2d_l3', n)],
        },
        {
          title: '',
          paragraphs: [t('pp_s2d_p2', n)],
        },
        {
          title: t('pp_s2e_title', n),
          paragraphs: [t('pp_s2e_p1', n)],
          items: [t('pp_s2e_l1', n), t('pp_s2e_l2', n), t('pp_s2e_l3', n)],
        },
        {
          title: '',
          paragraphs: [t('pp_s2e_p2', n)],
          items: [t('pp_s2e_l4', n), t('pp_s2e_l5', n), t('pp_s2e_l6', n)],
        },
        {
          title: t('pp_s2f_title', n),
          paragraphs: [t('pp_s2f_p1', n)],
          items: [t('pp_s2f_l1', n), t('pp_s2f_l2', n), t('pp_s2f_l3', n), t('pp_s2f_l4', n)],
        },
        {
          title: '',
          paragraphs: [t('pp_s2f_p2', n)],
        }
      ]
    },
    // Section 3: 我们如何使用个人数据
    {
      title: t('pp_s3_title', n),
      paragraphs: [t('pp_s3_p1', n)],
      subSections: [
        {
          title: t('pp_s3_sub1_title', n),
          items: [t('pp_s3_sub1_l1', n), t('pp_s3_sub1_l2', n), t('pp_s3_sub1_l3', n), t('pp_s3_sub1_l4', n)],
        },
        {
          title: t('pp_s3_sub2_title', n),
          items: [t('pp_s3_sub2_l1', n), t('pp_s3_sub2_l2', n), t('pp_s3_sub2_l3', n), t('pp_s3_sub2_l4', n), t('pp_s3_sub2_l5', n)],
        },
        {
          title: t('pp_s3_sub3_title', n),
          paragraphs: [t('pp_s3_sub3_p1', n)],
          items: [t('pp_s3_sub3_l1', n), t('pp_s3_sub3_l2', n), t('pp_s3_sub3_l3', n), t('pp_s3_sub3_l4', n), t('pp_s3_sub3_l5', n)],
        },
        {
          title: t('pp_s3_sub4_title', n),
          paragraphs: [t('pp_s3_sub4_p1', n)],
          items: [t('pp_s3_sub4_l1', n), t('pp_s3_sub4_l2', n), t('pp_s3_sub4_l3', n), t('pp_s3_sub4_l4', n)],
        },
        {
          title: t('pp_s3_sub5_title', n),
          paragraphs: [t('pp_s3_sub5_p1', n)],
          items: [t('pp_s3_sub5_l1', n), t('pp_s3_sub5_l2', n), t('pp_s3_sub5_l3', n)],
        },
        {
          title: t('pp_s3_sub6_title', n),
          paragraphs: [t('pp_s3_sub6_p1', n)],
          items: [t('pp_s3_sub6_l1', n), t('pp_s3_sub6_l2', n), t('pp_s3_sub6_l3', n), t('pp_s3_sub6_l4', n)],
        },
        {
          title: t('pp_s3_sub7_title', n),
          paragraphs: [t('pp_s3_sub7_p1', n)],
          items: [t('pp_s3_sub7_l1', n), t('pp_s3_sub7_l2', n), t('pp_s3_sub7_l3', n), t('pp_s3_sub7_l4', n)],
        },
        {
          title: t('pp_s3_sub8_title', n),
          paragraphs: [t('pp_s3_sub8_p1', n)],
          items: [t('pp_s3_sub8_l1', n), t('pp_s3_sub8_l2', n), t('pp_s3_sub8_l3', n)],
        },
        {
          title: '',
          paragraphs: [t('pp_s3_sub8_p2', n)],
        }
      ]
    },
    // Section 4: 个人数据的共享与披露
    {
      title: t('pp_s4_title', n),
      paragraphs: [t('pp_s4_p1', n)],
      subSections: [
        {
          title: t('pp_s4_sub1_title', n),
          paragraphs: [t('pp_s4_sub1_p1', n)],
          items: [t('pp_s4_sub1_l1', n), t('pp_s4_sub1_l2', n), t('pp_s4_sub1_l3', n), t('pp_s4_sub1_l4', n)],
        },
        {
          title: t('pp_s4_sub2_title', n),
          paragraphs: [t('pp_s4_sub2_p1', n)],
          items: [t('pp_s4_sub2_l1', n), t('pp_s4_sub2_l2', n), t('pp_s4_sub2_l3', n), t('pp_s4_sub2_l4', n)],
        },
        {
          title: '',
          paragraphs: [t('pp_s4_sub2_p2', n)],
        },
        {
          title: t('pp_s4_sub3_title', n),
          paragraphs: [t('pp_s4_sub3_p1', n)],
          items: [t('pp_s4_sub3_l1', n), t('pp_s4_sub3_l2', n), t('pp_s4_sub3_l3', n)],
        },
        {
          title: t('pp_s4_sub4_title', n),
          paragraphs: [t('pp_s4_sub4_p1', n)],
          items: [t('pp_s4_sub4_l1', n), t('pp_s4_sub4_l2', n), t('pp_s4_sub4_l3', n)],
        },
        {
          title: t('pp_s4_sub5_title', n),
          paragraphs: [t('pp_s4_sub5_p1', n)],
          items: [t('pp_s4_sub5_l1', n), t('pp_s4_sub5_l2', n), t('pp_s4_sub5_l3', n)],
        },
        {
          title: t('pp_s4_sub6_title', n),
          paragraphs: [t('pp_s4_sub6_p1', n)],
          items: [t('pp_s4_sub6_l1', n), t('pp_s4_sub6_l2', n), t('pp_s4_sub6_l3', n)],
        },
      ]
    },
    // Section 5: 跨境数据传输
    {
      title: t('pp_s5_title', n),
      paragraphs: [t('pp_s5_p1', n), t('pp_s5_p2', n)],
      items: [t('pp_s5_l1', n), t('pp_s5_l2', n), t('pp_s5_l3', n), t('pp_s5_l4', n)],
    },
    // Section 6: 数据保存期限
    {
      title: t('pp_s6_title', n),
      paragraphs: [t('pp_s6_p1', n)],
      items: [t('pp_s6_l1', n), t('pp_s6_l2', n), t('pp_s6_l3', n), t('pp_s6_l4', n)],
      subSections: [
        { title: '', paragraphs: [t('pp_s6_p2', n)] }
      ]
    },
    // Section 7: Cookies 与追踪技术
    {
      title: t('pp_s7_title', n),
      paragraphs: [t('pp_s7_p1', n)],
      items: [t('pp_s7_l1', n), t('pp_s7_l2', n), t('pp_s7_l3', n), t('pp_s7_l4', n)],
      subSections: [
        { title: '', paragraphs: [t('pp_s7_p2', n), t('pp_s7_p3', n)] }
      ]
    },
    // Section 8: 信息安全
    {
      title: t('pp_s8_title', n),
      paragraphs: [t('pp_s8_p1', n)],
      items: [t('pp_s8_l1', n), t('pp_s8_l2', n), t('pp_s8_l3', n), t('pp_s8_l4', n), t('pp_s8_l5', n)],
      subSections: [
        { title: '', paragraphs: [t('pp_s8_p2', n)] }
      ]
    },
    // Section 9: 您的隐私权利
    {
      title: t('pp_s9_title', n),
      paragraphs: [t('pp_s9_p1', n)],
      items: [t('pp_s9_l1', n), t('pp_s9_l2', n), t('pp_s9_l3', n), t('pp_s9_l4', n), t('pp_s9_l5', n)],
      subSections: [
        { title: '', paragraphs: [t('pp_s9_p2', n)] }
      ]
    },
    // Section 10: 区块链透明性与不可逆性
    {
      title: t('pp_s10_title', n),
      paragraphs: [t('pp_s10_p1', n), t('pp_s10_p2', n)],
      items: [t('pp_s10_l1', n), t('pp_s10_l2', n), t('pp_s10_l3', n), t('pp_s10_l4', n)],
      subSections: [
        {
          title: '',
          paragraphs: [t('pp_s10_p3', n), t('pp_s10_p4', n), t('pp_s10_p5', n), t('pp_s10_p6', n), t('pp_s10_p7', n), t('pp_s10_p8', n)],
          items: [t('pp_s10_l5', n), t('pp_s10_l6', n), t('pp_s10_l7', n), t('pp_s10_l8', n)],
        }
      ]
    },
    // Section 11: 与监管机构和执法机构的合作
    {
      title: t('pp_s11_title', n),
      paragraphs: [t('pp_s11_p1', n)],
      items: [t('pp_s11_l1', n), t('pp_s11_l2', n), t('pp_s11_l3', n), t('pp_s11_l4', n)],
      subSections: [
        {
          title: '',
          paragraphs: [t('pp_s11_p2', n)],
          items: [t('pp_s11_l5', n), t('pp_s11_l6', n), t('pp_s11_l7', n), t('pp_s11_l8', n)],
        },
        {
          title: '',
          paragraphs: [t('pp_s11_p3', n)],
          items: [t('pp_s11_l9', n), t('pp_s11_l10', n), t('pp_s11_l11', n), t('pp_s11_l12', n)],
        },
        {
          title: '',
          paragraphs: [t('pp_s11_p4', n)],
        }
      ]
    },
    // Section 12: 账户暂停与资产冻结
    {
      title: t('pp_s12_title', n),
      paragraphs: [t('pp_s12_p1', n)],
      items: [t('pp_s12_l1', n), t('pp_s12_l2', n), t('pp_s12_l3', n), t('pp_s12_l4', n), t('pp_s12_l5', n), t('pp_s12_l6', n)],
      subSections: [
        {
          title: '',
          paragraphs: [t('pp_s12_p2', n), t('pp_s12_p3', n)],
          items: [t('pp_s12_l7', n), t('pp_s12_l8', n), t('pp_s12_l9', n), t('pp_s12_l10', n)],
        },
        {
          title: '',
          paragraphs: [t('pp_s12_p4', n)],
        }
      ]
    },
    // Section 13: 联系方式
    {
      title: t('pp_s13_title', n),
      paragraphs: [t('pp_s13_p1', n)],
      subSections: [
        {
          title: '',
          paragraphs: [t('pp_s13_email', n) + PRIVACY_POLICY_EMAIL, t('pp_s13_company', n) + PRIVACY_POLICY_COMPANY],
        }
      ]
    },
  ], [t])

  return (
    <PageLayout>
      <Header
        leftChildren={<Back />}
        centerChildren={<span className='text-3.75 font-medium text-black'>{t('隐私政策')}</span>}
      />
      <div className="flex-1 overflow-y-auto px-6 py-6 text-[#1D2129]">
        {/* 主标题 */}
        <h1 className="text-6 font-bold mb-4">{t('pp_title', n)}</h1>
        <p className="text-4 mb-8">{t('pp_lastUpdate', n)}</p>

        {/* 分隔线 */}
        <div className="border-t border-gray-200 mb-8" />

        {/* 各章节 */}
        {sections.map((section, index) => (
          <SectionBlock key={index} {...section} />
        ))}
      </div>
    </PageLayout>
  )
})
